import { motion, useReducedMotion } from "framer-motion";
import { withBase } from "../../siteInfo";
import Reveal from "../../motion/Reveal";

const About = () => {
  const reduce = useReducedMotion();

  return (
    <section className="section" id="about">
      <div className="wrap split">
        <Reveal className="about-photos">
          <motion.img
            className="about-main"
            src={withBase("/images/campus/room-2.jpg")}
            alt="General ward with curtained beds at Rao Lokram Charitable Trust"
            whileHover={reduce ? undefined : { scale: 1.015 }}
            transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
          />
          <img
            className="about-side"
            src={withBase("/images/campus/room-1.jpg")}
            alt="Private inpatient room with a bed, attendant bench, and IV stand"
          />
        </Reveal>
        <Reveal className="prose" delay={0.08}>
          <p className="kicker">
            <span>01</span> About the trust
          </p>
          <h2>The hospital on Kadipur Road.</h2>
          <p>
            Rao Lokram Charitable Trust runs a 25-bed hospital for people who need
            treatment without corporate rates. The building is at Anaj Mandi Chowk,
            Shakti Park, Sector 10A, a short walk from Rockford School.
          </p>
          <p>
            Families come for everyday illness, pregnancy care, children’s problems,
            bone and joint pain, diabetes, and tests. Inpatient rooms are simple:
            a general ward with curtained beds, and private rooms with space for
            an attendant to sit.
          </p>
          <ul className="ticks">
            <li>Affordable treatment is the point of the trust, not a seasonal offer.</li>
            <li>Bring old reports and the strip of medicines you already take.</li>
            <li>There is no online form. The phone desk books visits and answers timing questions.</li>
            <li>Laboratory work is reported through NABL / ISO certified partner labs, including home collection.</li>
          </ul>
        </Reveal>
      </div>
    </section>
  );
};

export default About;
